import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {KTSVG} from '../../../helpers'
import {useLayout} from '../../core'

const SidebarLogo = () => {
  const {config} = useLayout()
  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default
  return (
    <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'>
      <Link to='/dashboard'>
        <svg
          className='h-45px app-sidebar-logo-default tr-logo-full'
          viewBox='0 0 95 57.86'
          xmlns='http://www.w3.org/2000/svg'
          role='img'
          aria-label='TaskRush'
        >
          <path
            fill='#53668c'
            d='M253.25,404.2l-.64,6.32,1.82-.28-.78,7.8q-.87,8.07,6.36,7.45l15.26-2.08.58-6.31-13.47,1.81q-2.06.07-2-1.92l.78-7.61,11.34-1.52.63-6.35L261.82,403l.21-2-6.69.86-.23,2-1.86.25Zm22.76,19,1.5-15.29q1-6.94,8.22-8.22l7.5-1q6.52-.45,6.13,6.21l-1.52,15.37-5.89.8.68-6.83-9.85,1.29-.66,6.84-6.11.84Zm9.95-18.3a2.42,2.42,0,0,0-2.33,2.66l-.26,2.39,9.83-1.33.21-1.88c.31-1.75-.18-2.64-1.49-2.66l-6,.82Zm34.83-4.08-12.27,1.66a12.56,12.56,0,0,0-1.93.38,2.2,2.2,0,0,0-1.17,1.14c.1.7.39,1.06.85,1.09a12.44,12.44,0,0,0,2.16-.16l6-.81q3.61-.3,5.05,1.4c1,1.13,1.33,2.82,1.11,5.1a9.4,9.4,0,0,1-2.38,5.31q-1.83,1.86-6.06,2.49l-13.39,1.82.57-5.76,12.73-1.73a18.73,18.73,0,0,0,2.51-.46,1.78,1.78,0,0,0,1.17-1.43c-.07-.6-.36-.93-.87-1a13,13,0,0,0-2.57.17l-5.8.79c-2.55.34-4.36,0-5.42-1.14s-1.48-2.77-1.26-5a9.52,9.52,0,0,1,2.51-5.37,11.36,11.36,0,0,1,6-2.57L321.36,395l-.57,5.85Zm1.37-6.09,7.25-1-1.06,10.82c-.42,4.29,0,0-.05.49l-1.1,11.2-7.25,1,2.21-22.5Z'
            transform='translate(-250.02 -392.22)'
          />
          <path
            fill='#b5cf52'
            d='M250,450.08l6.64-.91.69-7,5.87-.8,3,6.57,7.39-1-3.1-6.87a10.44,10.44,0,0,0,3.69-7.9c.24-4.28-2-6.5-6.61-6.63l-15.35,2.08L250,450.09Zm8.4-17.76,8.22-1.11c1.31,0,1.88.63,1.7,1.83a2.31,2.31,0,0,1-2.15,2.09L258,436.22Zm39.46-10.89-2.23,22.5-15,2q-6.51,1-6.14-6.23L276,424.42l5.87-.8-1.47,14.06c-.27,1.46.26,2.06,1.58,1.79l8.17-1.11,1.58-16.08,6.11-.84Zm20.8,3-12.27,1.66a12,12,0,0,0-1.92.39,2.12,2.12,0,0,0-1.18,1.13c.1.7.39,1.06.85,1.09a12.44,12.44,0,0,0,2.16-.16l6-.81q3.62-.29,5.05,1.41c1,1.12,1.33,2.82,1.11,5.1a9.37,9.37,0,0,1-2.38,5.3q-1.83,1.86-6.06,2.5l-13.39,1.81.57-5.75,12.73-1.73a20.51,20.51,0,0,0,2.51-.46,1.79,1.79,0,0,0,1.17-1.44c-.07-.6-.36-.92-.87-1a12,12,0,0,0-2.57.16l-5.8.79q-3.83.52-5.42-1.13c-1-1.1-1.48-2.77-1.25-5a9.48,9.48,0,0,1,2.5-5.37,11.4,11.4,0,0,1,6-2.57l13.08-1.78-.57,5.85ZM318,440.85l6.61-.9.85-8.66,8.24-1.12-.89,8.71,6.7-.88,2.21-22.56-6.61.85-.87,8.33L326,425.77l.82-8.3-6.62.9L318,440.85Z'
            transform='translate(-250.02 -392.22)'
          />
          <g className='tr-logo-piece tr-logo-piece-green'>
            <path
              fill='#b5cf52'
              d='M330.51,407a2.12,2.12,0,0,1-.78.14.81.81,0,0,1-.53-.34.78.78,0,0,1-.16-.56,2.63,2.63,0,0,1,.28-.74l6.86-11.57c.29-.49.59-1,1-1.72,0,0,.84.93,1.14,1.25l4.84,5.3L344.3,400s-.74,1.25-1,1.72l-2.67,4.5L339,404.5a2.59,2.59,0,0,0-2.9-.35l-5.51,2.79a.41.41,0,0,0-.11.07Z'
              transform='translate(-250.02 -392.22)'
            />
          </g>
          <g className='tr-logo-piece tr-logo-piece-blue'>
            <path
              fill='#53668c'
              d='M339,404.5l1.58,1.74,3.25,3.56c.29.3.66.72,1.14,1.25l-1.76.89-5.52,2.8-.17.08a2.57,2.57,0,0,1-2.73-.43l-.55-.61L330,409.09l-.56-.61a2.67,2.67,0,0,1-.12-3,2.63,2.63,0,0,0-.28.74.73.73,0,0,0,.15.56.86.86,0,0,0,.54.34,2.12,2.12,0,0,0,.78-.14,1.05,1.05,0,0,1,.11-.07l5.51-2.79,1.77-.9L339,404.5Z'
              transform='translate(-250.02 -392.22)'
            />
          </g>
        </svg>

        <svg
          className='h-45px app-sidebar-logo-minimize tr-logo-icon'
          viewBox='0 0 71.57 101.46'
          xmlns='http://www.w3.org/2000/svg'
          role='img'
          aria-label='TaskRush'
        >
          <g className='tr-logo-piece tr-logo-piece-green'>
            <path
              fill='#b5cf52'
              d='M269.14,435.79a8.87,8.87,0,0,1-3.48.64,3.6,3.6,0,0,1-2.37-1.49,3.24,3.24,0,0,1-.69-2.49,12.58,12.58,0,0,1,1.23-3.29l30.51-51.51c1.31-2.2,2.65-4.56,4.52-7.63,0,0,3.74,4.1,5.07,5.55l21.53,23.58,5.06,5.56L326,412.34l-11.87,20-7-7.72c-2.79-3-8.61-3.76-12.92-1.57l-24.54,12.44c-.17.08-.34.18-.5.27Z'
              transform='translate(-262.11 -370.02)'
            />
          </g>
          <g className='tr-logo-piece tr-logo-piece-blue'>
            <path
              fill='#53668c'
              d='M307.09,424.65l7,7.72,14.49,15.86q1.86,2.06,5.07,5.55l-7.85,4L301.3,470.21c-.26.13-.52.24-.78.35-4.22,1.75-9.52.95-12.15-1.93l-2.47-2.71-19-20.87-2.47-2.71c-2.79-3-3-9-.55-13.18a12.45,12.45,0,0,0-1.23,3.29,3.22,3.22,0,0,0,.69,2.49,3.61,3.61,0,0,0,2.37,1.48,8.87,8.87,0,0,0,3.48-.64l.49-.27,24.54-12.44c2.31-1.16,5.34-2.72,7.85-4,0,0,3.77,4.14,5.07,5.56Z'
              transform='translate(-262.11 -370.02)'
            />
          </g>
        </svg>
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            {active: appSidebarDefaultMinimizeDefault}
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export {SidebarLogo}
